import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ai-header-content" }
const _hoisted_2 = { class: "ai-header-text" }
const _hoisted_3 = { class: "ai-subtitle" }
const _hoisted_4 = { class: "ai-header-actions" }
const _hoisted_5 = {
  class: "drag-handle",
  title: "Drag to move"
}
const _hoisted_6 = { class: "ai-modal-body" }
const _hoisted_7 = { class: "ai-options" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "ai-generating"
}
const _hoisted_10 = {
  key: 1,
  class: "ai-generated"
}
const _hoisted_11 = { class: "generated-header" }
const _hoisted_12 = { class: "generated-title-row" }
const _hoisted_13 = {
  key: 0,
  class: "channel-pill"
}
const _hoisted_14 = { class: "generated-content" }
const _hoisted_15 = { class: "content-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["ai-modal-overlay", { 'ai-dragging-active': !_ctx.isInitialPosition }])
            }, [
              _createElementVNode("div", {
                ref: "modalRef",
                class: _normalizeClass(["ai-modal", { 'is-dragging': _ctx.isDragging }]),
                style: _normalizeStyle(_ctx.modalStyle),
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
                onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args)))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["ai-modal-header", { draggable: true }])
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_Icon, {
                      icon: "mdi:sparkles",
                      width: "18",
                      height: "18",
                      class: "ai-icon"
                    }),
                    _createElementVNode("div", _hoisted_2, [
                      _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "ai-title" }, "AI Personalization", -1)),
                      _createElementVNode("p", _hoisted_3, " Generate personalized content for " + _toDisplayString(_ctx.contactName || "Contact"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Icon, {
                        icon: "mdi:drag",
                        width: "16",
                        height: "16"
                      })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close-ai",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "mdi:close",
                        width: "18",
                        height: "18"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "ai-option",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAIAction('call'))),
                      disabled: _ctx.isGenerating
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "mdi:phone-outline",
                        width: "18",
                        height: "18"
                      }),
                      _cache[7] || (_cache[7] = _createElementVNode("span", null, "Generate Call Script", -1))
                    ], 8, _hoisted_8)
                  ]),
                  (_ctx.isGenerating)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("p", { class: "generating-text" }, "Generating...", -1),
                        _createElementVNode("div", { class: "personalizing-box" }, [
                          _createElementVNode("p", { class: "personalizing-text" }, "Personalizing content...")
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_ctx.showGeneratedContent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "generated-title" }, "Generated Content", -1)),
                            (_ctx.selectedType)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.channelLabel), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            class: "copy-btn",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyContent && _ctx.copyContent(...args)))
                          }, [
                            _createVNode(_component_Icon, {
                              icon: "mdi:content-copy",
                              width: "16",
                              height: "16"
                            }),
                            _cache[10] || (_cache[10] = _createElementVNode("span", null, "Copy", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("pre", _hoisted_15, _toDisplayString(_ctx.generatedContent), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 38)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}